<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="ded"><em>To Sarah, my sister (in-law).<br/>Thank you for becoming my sister.<br/>For your continuous love, your sense of humor,<br/>and your kindness. You light up our lives.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?5348b080